/*
 * socket.io client options shared by every push-style socket. A leaf module by design: worker
 * setup graphs import it (ADR 0016), where pulling in `src/lib/push`'s module-scope
 * StaticContainer logger read would drag main-thread bootstrap into the worker bundle.
 */
import { reviver } from '@thinkalpha/common/serialization/serializer.js';
import type { ManagerOptions, SocketOptions } from 'socket.io-client';
import { Decoder, Encoder } from 'socket.io-parser';

/**
 * Options for sockets whose payloads are decoded through the zod contract schemas at the socket
 * boundary (ADR 0016 workers): the stock socket.io parser, so the server's ISO strings reach the
 * schema codecs as strings. The pattern reviver below would turn them into js-joda values first,
 * which the codecs — expecting the wire form — reject.
 */
export const SCHEMA_DECODED_CONNECTION_OPTIONS = {
    forceNew: true,
    timeout: 10000,
    transports: ['websocket'],
} satisfies Partial<ManagerOptions & SocketOptions>;

/**
 * Options for sockets whose consumers read payloads directly, without a schema decode: the
 * legacy pattern reviver turns ISO date/time strings into js-joda values as they are parsed.
 */
export const CONNECTION_OPTIONS = {
    ...SCHEMA_DECODED_CONNECTION_OPTIONS,
    parser: {
        Encoder: Encoder,
        Decoder: class extends Decoder {
            constructor() {
                super(reviver);
            }
        },
    },
} satisfies Partial<ManagerOptions & SocketOptions>;
